<app-layout>
  <app-voltar route="listagem/estacionamento-tpg" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>
        Entrada de Estacionamento de Tampas, Grades e Paletes
      </app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (ngModelChange)="clearForms()">
      <app-subtitulo> Informe os dados para iniciar o serviço </app-subtitulo>
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          (blurEvent)="setForms()"
          mask="AAA-0A00"
          [requiredInput]="true"></app-input>
        <app-input
          type="number"
          label="N° do Agendamento"
          name="FK_AGND"
          formControlName="FK_AGND"
          placeholder="Digite aqui"
          (blurEvent)="getAgendamentoOrCavalo()"
          mask="0000"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Aguardando"
          [disabled]="true"></app-input>
      </div>
      <app-subtitulo>
        Informe a placa da carreta para associar estacionamento de tampa, grade
        ou palete
      </app-subtitulo>
      <div class="formList">
        <app-select-check
          type="select"
          label="Placa(s) da(s) Carreta(s)"
          [placeholder]="carretasSelecionadas"
          (ngModelChange)="onCarretaChange($event)"
          [selectData]="carretaOptions"
          [requiredInput]="true"
          [disabled]="isViewing"></app-select-check>
        <app-input
          type="select"
          label="Item"
          name="NU_ITEM_MOVM"
          formControlName="NU_ITEM_MOVM"
          (ngModelChange)="onItemChange($event)"
          [selectData]="itemOptions"
          [requiredInput]="true"></app-input>
        <div>
          <app-input
            type="text"
            label="Quantidade Movimentada"
            name="QT_MOVM_PLTE"
            formControlName="QT_MOVM_PLTE"
            placeholder="Digite aqui"
            [requiredInput]="true" />
          <div
            *ngIf="
              form.get('QT_MOVM_PLTE')?.invalid &&
              form.get('QT_MOVM_PLTE')?.touched
            ">
            <small
              class="text-danger"
              *ngIf="form.get('QT_MOVM_PLTE')?.errors?.['pattern']">
              Máximo de 4 dígitos numéricos.
            </small>
          </div>
        </div>
        <app-input
          type="textarea"
          class="grid-2fr"
          label="Observação"
          name="TX_OBSV_MOVM_PLTE"
          formControlName="TX_OBSV_MOVM_PLTE"
          placeholder="Digite aqui"></app-input>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        text="Registrar Entrada"
        class="botao-cadastro"
        (click)="postPalete()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
